import React from "react"
import {
  RegBody,
  SemiBdTitle5,
  SemiBdTitle2,
  Accordion,
} from "@sr/gatsby-theme-ui"
import styled from "styled-components"
import { rem } from "polished"
import { media } from "@sr/common"

export interface ProductEntryFaqProps {
  faq: {
    on: boolean
    body: string
    header: string
    accordionArray: { body: string; title: string }[]
  }
}

const ProductEntryFaq = ({ faq }: ProductEntryFaqProps) => {
  if (!faq?.on) return null
  const faqItems =
    faq?.accordionArray?.length &&
    faq.accordionArray.map((accordionItem: any, i: number) => {
      return {
        title: (
          <SemiBdTitle5 as="span" className="product-entry-faq__faq-item-title">
            {accordionItem.title}
          </SemiBdTitle5>
        ),
        content: (
          <RegBody as="span" className="product-entry-faq__faq-item-body">
            {accordionItem.body}
          </RegBody>
        ),
        id: i,
        key: i,
      }
    })
  return (
    <ProductEntryFaqStyled>
      <SemiBdTitle2 className="product-entry-faq__header">
        {faq?.header && faq.header}
      </SemiBdTitle2>
      {faq?.body ? (
        <RegBody className="product-entry-faq__body">
          {faq?.body && faq.body}
        </RegBody>
      ) : null}
      {faq?.accordionArray?.length && (
        <Accordion
          className="product-entry-faq__faq"
          collapsible={true}
          defaultActiveItem={0}
          items={faqItems}
        />
      )}
    </ProductEntryFaqStyled>
  )
}

export default ProductEntryFaq

const ProductEntryFaqStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${rem(144)} ${rem(16)} 0;
  text-align: left;

  .icon {
    fill: var(--color-gray800);
  }

  @media ${media.midUp} {
    padding: ${rem(128)} ${rem(64)} 0;
  }

  @media ${media.stMidUp} {
    max-width: ${rem(952)};
    padding-top: ${rem(152)};
  }

  .product-entry-faq__header {
    font-size: ${rem(24)};

    @media ${media.midUp} {
      font-size: ${rem(40)};
      padding-bottom: ${rem(16)};
    }
  }

  .product-entry-faq__faq {
    padding-top: ${rem(32)};
    text-decoration: none;
  }

  .product-entry-faq__faq-item-title {
    text-align: left;

    @media ${media.midUp} {
      font-size: ${rem(24)};
      line-height: ${rem(32)};
    }

    @media ${media.stMidUp} {
      padding: ${rem(8)} 0;
    }
  }

  .product-entry-faq__faq-item-body {
    @media ${media.midUp} {
      font-size: ${rem(16)};
    }
  }

  .accordion-header__button {
    color: var(--color-gray800);
    padding-left: ${rem(8)};
  }
`
